<script lang="ts">
    import { AuthService, type User } from '../../lib/api/auth.service';
    import { onMount } from 'svelte';
    
    export let params = { page: '' };
    
    let user: User | null = null;
    let loading = true;
    
    onMount(async () => {
      const localUser = AuthService.getUser();
      
      if (localUser) {
        user = localUser;
      } else {
        try {
          const result = await AuthService.getCurrentUser();
          if (result.success && result.user) {
            user = result.user;
          }
        } catch (err) {
          console.error('Error fetching user:', err);
        }
      }
      
      loading = false;
    });
  </script>
  
  {#if loading}
    <div class="loading-container">
      <div class="loading">Loading...</div>
    </div>
  {:else}
    <div class="placeholder-container">
      <div class="placeholder-card">
        <h2>{params.page.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')} Page</h2>
        <p>This page is under construction.</p>
        <p>The requested route is: <code>/{params.page}</code></p>
      </div>
    </div>
  {/if}
  
  <style>
    .loading-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      background-color: #f7fafc;
    }
    
    .loading {
      text-align: center;
      padding: 2rem;
      border-radius: 8px;
      background-color: white;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }
    
    .placeholder-container {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 2rem;
    }
    
    .placeholder-card {
      background-color: white;
      border-radius: 8px;
      padding: 2rem;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
      max-width: 600px;
      width: 100%;
      text-align: center;
    }
    
    h2 {
      color: #2d3748;
      margin-top: 0;
    }
    
    p {
      color: #4a5568;
      margin-bottom: 1rem;
    }
    
    code {
      background-color: #edf2f7;
      padding: 0.2rem 0.4rem;
      border-radius: 4px;
      font-family: monospace;
      color: #e53e3e;
    }
  </style>